<div class="container rtl iran-sans" data-aos="fade-up">

    <div class="section-title">
        <h2>اشتراک دانش و تجربه </h2>
        <p>
            دسترسی به تجربه تشخیص و درمان پزشکی
        </p>
    </div>

    <div class="row">

    </div>
    <div class="row portfolio-container" data-aos="fade-up" data-aos-delay="200">

        <div class="col-lg-6 col-md-6 portfolio-item filter-app">
            <div class="portfolio-wrap">
                <div class="row w-100 p-4">
                    <h4 class="portfolio-title">بیماران مثل من</h4>
                </div>
                <img src="assets/img/social2.png" class="img-fluid" alt="">
                <div class="portfolio-info p-4">
                    <p class="p-4">
                        ما سعی می‌کنیم، به‌روزترین اطلاعات سلامت و جدیدترین روش‌های مراقبت بهداشتی، درمانی را در این بخش
                        در اختیارتان قرار دهیم. اعتقاد داریم که در اختیار داشتن اطلاعات مفید، صحیح و دقیق در خصوص
                        بیماری‌ها، علائم و نشانه‌ها، اقدامات تشخیصی مانند انواع آزمایشات و تصویربرداری‌های پزشکی، و
                        اقدامات درمانی مانند داروها، مکمل‌ها و سایر اقدامات پزشکی به حفظ سلامتی و پیگیری روش‌های مطلوب
                        درمانی کمک خواهد نمود.
                    </p>
                </div>
            </div>
        </div>

        <div class="col-lg-6 col-md-6 portfolio-item filter-web">
            <div class="portfolio-wrap">
                <div class="row w-100 p-4">
                    <h4 class="portfolio-title">اطلاعات سلامت</h4>
                </div>
                <img src="assets/img/social1.png" class="img-fluid" alt="">
                <div class="portfolio-info">
                    <p class="p-4">
                        هر فرد ممکن است در طول زندگی با بیماری‌ها و شرایط سختی روبرو شود که منجر به اضطراب و نگرانی خود و
                        اطرافیان شده و دغدغه پیگیری و درمان آن همواره برای ایشان وجود خواهد داشت. باید بدانیم در کشور
                        عزیزمان، افراد دیگری هم هستند که آن بیماری یا شرایط را تجربه کرده و با علاقه و اشتیاق، تجربه خود
                        در زمینه روش‌های تشخیصی، درمانی یا کنترل شرایط را برای شما به اشتراک گذاشته‌اند، تا بدین‌وسیله
                        بخشی از رنج‌ها و دغدغه‌های شما را کاهش دهند. در این بخش سعی کرده‌ایم این امکان را برای شما فراهم
                        نماییم.
                    </p>
                </div>
            </div>
        </div>

        <!-- <div class="col-lg-4 col-md-6 portfolio-item filter-app">
        <div class="portfolio-wrap">
          <img src="assets/img/portfolio/portfolio-3.jpg" class="img-fluid" alt="">
          <div class="portfolio-links">
            <a href="assets/img/portfolio/portfolio-3.jpg" data-gallery="portfolioGallery" class="portfolio-lightbox" title="App 2"><i class="bi bi-plus"></i></a>
            <a href="portfolio-details.html" title="More Details"><i class="bi bi-link"></i></a>
          </div>
          <div class="portfolio-info">
            <h4>App 2</h4>
            <p>App</p>
          </div>
        </div>
      </div> -->

        <!-- <div class="col-lg-4 col-md-6 portfolio-item filter-card">
        <div class="portfolio-wrap">
          <img src="assets/img/portfolio/portfolio-4.jpg" class="img-fluid" alt="">
          <div class="portfolio-links">
            <a href="assets/img/portfolio/portfolio-4.jpg" data-gallery="portfolioGallery" class="portfolio-lightbox" title="Card 2"><i class="bi bi-plus"></i></a>
            <a href="portfolio-details.html" title="More Details"><i class="bi bi-link"></i></a>
          </div>
          <div class="portfolio-info">
            <h4>Card 2</h4>
            <p>Card</p>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 portfolio-item filter-web">
        <div class="portfolio-wrap">
          <img src="assets/img/portfolio/portfolio-5.jpg" class="img-fluid" alt="">
          <div class="portfolio-links">
            <a href="assets/img/portfolio/portfolio-5.jpg" data-gallery="portfolioGallery" class="portfolio-lightbox" title="Web 2"><i class="bi bi-plus"></i></a>
            <a href="portfolio-details.html" title="More Details"><i class="bi bi-link"></i></a>
          </div>
          <div class="portfolio-info">
            <h4>Web 2</h4>
            <p>Web</p>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 portfolio-item filter-app">
        <div class="portfolio-wrap">
          <img src="assets/img/portfolio/portfolio-6.jpg" class="img-fluid" alt="">
          <div class="portfolio-links">
            <a href="assets/img/portfolio/portfolio-6.jpg" data-gallery="portfolioGallery" class="portfolio-lightbox" title="App 3"><i class="bi bi-plus"></i></a>
            <a href="portfolio-details.html" title="More Details"><i class="bi bi-link"></i></a>
          </div>
          <div class="portfolio-info">
            <h4>App 3</h4>
            <p>App</p>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 portfolio-item filter-card">
        <div class="portfolio-wrap">
          <img src="assets/img/portfolio/portfolio-7.jpg" class="img-fluid" alt="">
          <div class="portfolio-links">
            <a href="assets/img/portfolio/portfolio-7.jpg" data-gallery="portfolioGallery" class="portfolio-lightbox" title="Card 1"><i class="bi bi-plus"></i></a>
            <a href="portfolio-details.html" title="More Details"><i class="bi bi-link"></i></a>
          </div>
          <div class="portfolio-info">
            <h4>Card 1</h4>
            <p>Card</p>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 portfolio-item filter-card">
        <div class="portfolio-wrap">
          <img src="assets/img/portfolio/portfolio-8.jpg" class="img-fluid" alt="">
          <div class="portfolio-links">
            <a href="assets/img/portfolio/portfolio-8.jpg" data-gallery="portfolioGallery" class="portfolio-lightbox" title="Card 3"><i class="bi bi-plus"></i></a>
            <a href="portfolio-details.html" title="More Details"><i class="bi bi-link"></i></a>
          </div>
          <div class="portfolio-info">
            <h4>Card 3</h4>
            <p>Card</p>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 portfolio-item filter-web">
        <div class="portfolio-wrap">
          <img src="assets/img/portfolio/portfolio-9.jpg" class="img-fluid" alt="">
          <div class="portfolio-links">
            <a href="assets/img/portfolio/portfolio-9.jpg" data-gallery="portfolioGallery" class="portfolio-lightbox" title="Web 3"><i class="bi bi-plus"></i></a>
            <a href="portfolio-details.html" title="More Details"><i class="bi bi-link"></i></a>
          </div>
          <div class="portfolio-info">
            <h4>Web 3</h4>
            <p>Web</p>
          </div>
        </div>
      </div> -->

    </div>

</div>